import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import {
  withStyles,
} from '@material-ui/core/styles';

const StyledDialg = withStyles(() => ({
  root: {
    '&.MuiDialog-root .MuiDialog-paper': {
      background: '#fff',
      borderRadius: '8px',
      padding: '0',
      maxWidth: '560px',
    },

    '&.MuiDialog-root .MuiDialogTitle-root': {
      textAlign: 'left',
      fontWeight: '600',
      fontSize: '20px',
      padding: '24px 24px 12px 24px',
    },

    '&.MuiDialog-root .MuiDialogContent-root': {
      textAlign: 'left',
      padding: '12px 24px',
    },

    '&.MuiDialog-root h2.MuiTypography-root': {
      fontSize: '20px',
      lineHeight: '22px',
      fontWeight: '600',
    },
    '&.MuiDialog-root p': {
      fontSize: '16px',
      lineHeight: '22px',
    },
    '&.MuiDialog-root .MuiDialogActions-root': {
      background: '#F4F4F4',
    },
    '&.MuiDialog-root .MuiDialogActions-root.actnbtnSWrap': {
      justifyContent: 'none',
    },

    '&.MuiDialog-root .MuiDialogActions-root.actnbtnSWrap .MuiButton-root': {
      textTransform: 'none',
      borderRadius: '50px',
      padding: '6px 20px',
    },
    '&.MuiDialog-root .MuiDialogActions-root.actnbtnSWrap .MuiButton-root.iunderstand': {
      background: '#1367B2',
      color: '#fff',
      padding: '6px 20px',
    },
    '&.MuiDialog-root .MuiDialogActions-root.actnbtnSWrap .MuiButton-root.disabled': {
      background: '#999999',
      color: '#fff',
      padding: '6px 20px',
    },

    '&.Mui-checked': {
      color: '#1367B2',
    },
  },
}))(Dialog);

const StyledDialog = ({
  open, fullWidth = true, children, close = () => { },
}) => (
  <StyledDialg open={open} fullWidth={fullWidth} onClose={close}>{children}</StyledDialg>
);

export default StyledDialog;
